import { get, post, path_version } from '@/httpRequest/http'
const { VUE_APP_OPEN_ACCOUNT } = process.env
import { getBaseUrl } from '@/utils'
import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js'
const baseUrl = getBaseUrl(VUE_APP_OPEN_ACCOUNT)

/** 查询用户的账号信息及星财宝专户开户申请状态。 */
export const XjbState = data => {
    return post(baseUrl + `/account/${path_version}/XjbState`, {
        data,
        showFreezeToast: false,
    })
}

/** 获取星财宝专户开户风险披露声明 */
export const GetRiskDisclosureInfo = params => {
    return get(baseUrl + `/account/${path_version}/GetRiskDisclosureInfo`, {
        params,
    })
}

/** 提交星财宝专户开户申请 */
export const XjbSubmit = data => {
    return post(baseUrl + `/account/${path_version}/XjbSubmit`, {
        data,
        encTag: JSBridge ? 'tradeverify/enc' : 'trade/enc',
        isTrade: true,
    })
}

/** 星财宝专户重新提交 */
export const XjbReSubmit = data => {
    return post(baseUrl + `/account/${path_version}/XjbReSubmit`, {
        data,
    })
}

/** 星财宝专户获取授权人 */
export const GetCorpAuthorizers = params => {
    return get(baseUrl + `/account/${path_version}/GetCorpAuthorizers`, {
        params,
    })
}

/** 查询用户PI详情 */
export const PIDetail = params => {
    return get(baseUrl + `/client/${path_version}/PIDetail`, {
        params,
    })
}
